import React, { Component } from 'react'
import Form, { baseError } from 'components/Form'
import Input from 'components/Form/Input'
import api from 'api'
import { Row } from 'components/layout/flex'
import { required, minLength } from 'components/Form/validations'

const states = 'AK,AL,AR,AZ,CA,CO,CT,DC,DE,FL,GA,HI,IA,ID,IL,IN,KS,KY,LA,MA,MD,ME,MI,MN,MO,MS,MT,NC,ND,NE,NH,NJ,NM,NV,NY,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VA,VT,WA,WI,WV,WY'.split(',')

export default class ValidateAddress extends Component {
  handleData = data => {
    return api.post('address_validations', data).then(resp => {
      const { state, city, street, zip } = resp.data
      const stateAndZip = [state, zip].filter(x => x).join(' ')
      const addressStr = [street, city, stateAndZip].filter(x => x).join(', ')
      this.props.onValidAddress({ ...resp.data, text: addressStr })
    }).catch(err => {
      if (this.props.onFailure) {
        this.props.onFailure()
      }
      return baseError('Address not valid.  Please try again or contact support.')
    })
  }
  render() {
    return (
      <Form onData={this.handleData}>
        <Input tight label="Street" name="street" validate={required} />
        <Input label="Apt, Building, Suite (Optional)" name="apt_number" maxLength={25} />
        <Input label="City" name="city" validate={required} />
        <Row>
          <Input.Select label="State" name="state" validate={required}>
            {states.map(state => <option key={state} value={state}>{state}</option>)}            
          </Input.Select>
          <Input label="Zip" name="zip" type="tel" kind="zip" maxLength={5} validate={minLength(5).withMessage('Must be exactly 5 digits.').required()} />
        </Row>
        <Input.Submit>Validate Address</Input.Submit>
      </Form>
    )
  }
}